const scrollIndicator = require('../../../plugins/indicateInnerScroll/js/scrollIndicator.module');

const s = {
    id: 'sections-navbar', // also serves as a css source as a class
    observerOptions: {
        threshold: 0,
        rootMargin: '-30% 0% -65% 0%',
    },
    init: (sections, articleView) => {
        s.main = document.querySelector('[data-core-nav="article"]') || document.getElementById(s.id);
        s.main.classList.add(s.id);

        const containerExisting = s.main.querySelector('.' + s.id + '__container');

        if (!containerExisting) {
            const container = document.createElement('div');
            container.classList.add(s.id + '__container');
            container.innerHTML = s.main.innerHTML;
            s.main.innerHTML = container.outerHTML;
        }

        if (s.main) {
            const list = s.main.querySelector(`.${s.id}__list`) || s.main.querySelector('ul');
            if (list) {
                const listNew = list.cloneNode(true);
                listNew.innerHTML = '';
                if (sections.length) {
                    sections.map(o => {
                        let link = s.createNavItem(o, listNew);
                        o.sectionParent.navbarPointer = link;
                        listNew.appendChild(link);
                        s.observe(o.sectionParent);
                    });
                } else {
                    s.main.classList.add(`${s.id}--empty`);
                }

                if (articleView) {
                    this.articleView = articleView;
                }

                list.parentNode.replaceChild(listNew, list);
                s.list = listNew;
                scrollIndicator.initFor(listNew);
            }
            // @TODO implement event delegation
            // $(s.main).on('click', 'a', e => {
            //     console.log(e)
            // })
            return s.main;
        }
    },

    update: function () {
        scrollIndicator.markInnerScroll({target: s.list});
    },

    createNavItem: (item, list) => {
        const link = document.createElement('a');
        link.href = '#' + item.id;
        link.innerHTML = item.innerHTML;
        // Trim inner links as they cause numerous problems
        const innerlinks = link.querySelectorAll('a');
        innerlinks?.forEach(a => {
            const span = document.createElement('span');
            span.innerText = a.innerText;
            link.replaceChild(span, a);
        });
        link.classList.add(`${s.id}__list__item`);
        link.addEventListener('click', e => s.moveTo(e, item));

        const container = document.createElement('li');
        container.appendChild(link);
        return container;
    },

    observe: elem => {
        // will observer work on a non DOM elem?
        if (typeof window.IntersectionObserver !== 'undefined') {
            if (!s.observer) {
                s.observer = new IntersectionObserver(s.onIntersectionChange, s.observerOptions);
            }
            s.observer.observe(elem);
        }
    },

    onIntersectionChange: (entries, observer) => {
        entries.map(entry => {
            if (entry.isIntersecting) {
                const prevActive = s.main.querySelector('.active'); // @TODO find a better way to do that
                if (prevActive) {
                    prevActive.classList.remove('active');
                }
                entry.target.navbarPointer.classList.add('active');
            } else {
                entry.target.navbarPointer.classList.remove('active');
            }
        });
    },

    moveTo: (e, target) => {
        e.preventDefault();
        // since we already have this good animation library it would be extremely ... to write or import another one
        const targetTopCorrection = this.articleView ? this.articleView.getTopOverlayHeight() : 0;
        $('html, body').animate({scrollTop: target.offsetTop - targetTopCorrection}, 500);
    },
};
const sectionNavbar = s;

module.exports = sectionNavbar;
